module.exports = __webpack_public_path__ + "img/top_left.0f2c08f5.png";